var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:{ 'mt-6': _vm.data.length <= 1 },attrs:{"fluid":""}},[_c('v-sparkline',{attrs:{"fill":_vm.fill,"gradient":_vm.selectedGradient,"line-width":_vm.width,"padding":_vm.padding,"smooth":_vm.radius || false,"value":_vm.data,"auto-draw":""}}),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }